import Swiper, { Manipulation, Navigation, Pagination } from "swiper"
Swiper.use([Navigation, Manipulation, Pagination])
export default new (class LactoseFreeProductCaorusel {
    constructor() {
        this.sliderContainerSelector = "carousel-lactose-free-product"
        this.sliderNextSelector = "carousel-product-next"
        this.sliderPrevSelector = "carousel-product-prev"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.slider-lactose-free .${this.sliderContainerSelector}`).forEach((item) => {
            if (item.classList.contains("swiper-initialized")) return;
            const arProducts = Array.from(item.querySelectorAll('.swiper-slide'));
            const swiper =  new Swiper(item, {
                slidesPerView: 4,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        // slidesPerView: 1.95,
                        slidesPerView: item.closest('.slider-search') ? 1.90 : 2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 8,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1280: {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: item.closest('.slider-lactose-free_questioannaire') ? 'auto' : 4,
                        spaceBetween: 16,
                    },
                },
            })

            const filterWrap = document.querySelector('.filter_lactose')
            filterWrap.addEventListener('change', (e) => {
                swiper.removeAllSlides();
                const arCheckedCategories = Array.from(filterWrap.querySelectorAll(':checked')).map((input) => input.value);
                if (!arCheckedCategories.length) {
                    swiper.appendSlide(arProducts)
                } else {
                    swiper.appendSlide(arProducts.filter((slide) => arCheckedCategories.includes(slide.dataset.category)));
                }
                swiper.update();
            })
        })

        document.querySelectorAll('.slider-lactose-info').forEach(item => {
            new Swiper(item.querySelector(`.swiper-container`), {
                spaceBetween: 10,
                slidesPerView: 'auto',
                watchSlidesProgress: true,
                // autoHeight: true,
                navigation: {
                    nextEl: item.querySelector(`.swiper-button-next`),
                    prevEl: item.querySelector(`.swiper-button-prev`),
                },
                pagination: {
                    el: item.querySelector(`.swiper-pagination`),
                    clickable: true,
                },
            });
        })
    }
})()
